import React from "react";

export default function PrivacyAndTerms() {
  return (
    <div className="p-20 max-w-4xl mx-auto space-y-10">
      {/* Privacy Policy Section */}
      <section className="bg-white shadow-md rounded-2xl p-6 space-y-4 mt-20">
        {/* Added mt-20 for extra top margin */}
        <h1 className="text-3xl font-bold">Privacy Policy</h1>
        <h2 className="text-xl font-semibold">Mowgi Communications Privacy Policy</h2>
        <p>1. <strong>Introduction</strong></p>
        <p>
          This Privacy Policy describes how Mowgi Communications collects, uses, and
          protects your personal information. By using our website or services, you
          consent to the practices described in this policy.
        </p>

        <p>2. <strong>Information We Collect</strong></p>
        <p>
          We may collect personal information such as your name, email address, phone
          number, and company information when you contact us, register for our
          services, or participate in our events. We may also collect information
          about your interactions with our website, such as pages visited and links
          clicked.
        </p>

        <p>3. <strong>How We Use Your Information</strong></p>
        <p>
          We use your information to provide you with our services, respond to your
          inquiries, personalize your experience, and improve our website and
          services. We may also use your information to send you important
          communications, such as updates about our services or events.
        </p>

        <p>4. <strong>Information Sharing</strong></p>
        <p>
          We do not sell or share your personal information with third parties except
          as necessary to provide you with our services or as required by law.
        </p>

        <p>5. <strong>Security</strong></p>
        <p>
          We implement reasonable security measures to protect your personal
          information from unauthorized access, use, or disclosure.
        </p>

        <p>6. <strong>Your Rights</strong></p>
        <p>
          You have the right to access, correct, or delete your personal information.
          Please contact us at <a href="mailto:teams@mowgicommunications.com" className="text-blue-600 underline">teams@mowgicommunications.com</a> to exercise these rights.
        </p>

        <p>7. <strong>Changes to this Policy</strong></p>
        <p>
          We may update this Privacy Policy from time to time. We will post any
          changes on this page, so please review it periodically.
        </p>

        <p>8. <strong>Contact Us</strong></p>
        <p>
          If you have any questions or concerns about this Privacy Policy, please
          contact us at <a href="teams@mowgicommunications.com" className="text-blue-600 underline">teams@mowgicommunications.com</a>.
        </p>

        <p className="text-sm text-gray-500">
          Copyright © 2025 Mowgi Communications. All rights reserved.
        </p>
      </section>
    </div>
  );
}
